import { Injectable } from "@angular/core";
import { ClientService } from "../services/client.service";
import { ArrayClientRepository } from "./abstract/array.client.repository";
import { PrintableLookUp } from "../types/Printable/PrintableLookUp";

@Injectable({
  providedIn: "root",
})
export class PrintableLookUpRepository extends ArrayClientRepository<PrintableLookUp> {
  constructor(clientService: ClientService) {
    super(
      clientService,
      "schemas.schCFG_IREF_Printable_LKP_Pages.records",
      "pageID",
    );
  }
}
